<template>
  <div>
    <van-sticky>
      <div style="display: flex; justify-content: space-around; align-items: center; padding: 8px 0">
        <span style="color: deepskyblue; font-weight: 500"> 内领单据列表</span>
        <van-button v-if="!readOnly" style="color: deepskyblue; font-weight: 500; width: 100px" @click="selectGoods"
                    size="normal">
          选择商品
        </van-button>
      </div>
      <div style="border-top: solid 1px gray; height: 0"></div>
    </van-sticky>

    <div :style="{'height': listHeight + 'px'}" style="background-color: darkgray; overflow: scroll">
      <transition-group name="list-complete">
        <div style="background-color: white; padding: 8px 0" key="top">
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">单据编号</label>
            <span v-if="!!neiling.id" class="value">{{ neiling.code }}</span>
            <el-input v-else class="value" v-model="neiling.code" style="width: 150px"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">选择仓库</label>
            <span v-if="readOnly" class="value">{{
                neiling.warehouseId | valueName('Warehouse')
              }}-{{ neiling.warehousePosId | valueName('WarehousePos') }}
            </span>
            <wx-warehouse-select v-else class="value" v-model="neiling.warehouse"
                                 style="position: relative; top: -4px"></wx-warehouse-select>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label"> 内领日期</label>
            <span v-if="readOnly" class="value">{{ neiling.outDate }}</span>
            <wx-date-select v-else class="value" v-model="neiling.outDate"
                            style="position: relative; top: -4px"></wx-date-select>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">经办人</label>
            <span v-if="readOnly" class="value">{{ neiling.operatorUserName }}</span>
            <remote-van-select v-else class="value" class-name="NeilingUser" v-model="neiling.operatorUserAccount"
                               :options="neilingUserOptions" style="position: relative; top: -4px">
            </remote-van-select>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">备注</label>
            <el-input class="value" v-model="neiling.remarks" style="width: 200px" :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">物流公司</label>
            <el-input class="value" v-model="neiling.logisticsCompany" style="width: 200px"
                      :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">物流单号</label>
            <el-input class="value" v-model="neiling.logisticsCode" style="width: 200px"
                      :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">运费金额</label>
            <el-input class="value" v-model="neiling.freight" style="width: 200px" :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">结算账户</label>
            <el-input class="value" v-model="neiling.settlementAccount" style="width: 200px"
                      :disabled="readOnly"></el-input>
          </div>
        </div>
        <div style="border-top: solid 1px gray; height: 0" key="line"></div>
        <div v-for="(item, index) of neiling.goodsList" :key="item.id"
             style="background-color: white; margin: 0 4px 8px 4px; padding: 6px; overflow: hidden;"
             class="list-complete-item">
          <div>
            <div style="height: 26px; line-height: 28px;" :style="{'margin-top': index > 0 ? '6px' : 0}">
              <label class="label">序号</label>
              <span class="value">
              <span style="width: 30px; display: inline-block">{{ index }}</span>
            </span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品编号</label>
              <span class="value">{{ item.code }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品名称</label>
              <span class="value">{{ item.name }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品类型</label>
              <span class="value">{{ item.typeCode | valueName('GOODS_TYPE') }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">生产日期</label>
              <span class="value">{{ item.productionDate }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">有效期</label>
              <span class="value">{{ item.expireDays + ' 天' }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">单位</label>
              <span class="value">{{ item.unit }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">数量</label>
              <span class="value">{{ item.num }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品单价</label>
              <span class="value">{{ item.price + ' 元' }}</span>
              <van-button v-if="!readOnly" plain hairline type="danger" style="float: right; margin: 0 10px 6px 0"
                          size="small"
                          @click="deleteGoods(item)">删除商品
              </van-button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <!--    <div style="border-top: solid 1px gray; height: 0"></div>-->
    <div style="display: flex; justify-content: center; background-color: white; padding: 20px">
      <template v-if="!readOnly">
        <van-button type="primary" style="margin-right: 20px; width: 150px" @click="applyNeiling">内 领</van-button>
        <van-button style="margin-right: 20px; width: 150px" @click="save">保 存</van-button>
        <van-button style="width: 150px" @click="cancel">取 消</van-button>
      </template>
      <el-button v-else @click="cancel">返 回</el-button>
    </div>

    <wx-select-out-goods v-model="selectGoodsPopup.show" :outbound="selectGoodsPopup.neiling"
                         @update="updateGoodsList" :cand-goods-list="goodsList"></wx-select-out-goods>
  </div>
</template>

<script>
import { Neiling } from '@/store/objdef/objectDef'
import { Button, Popup, Search, Sticky, Tag, Field, DatetimePicker, Toast } from 'vant'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import WxWarehouseSelect from '@/views/wx/product/WxWarehouseSelect'
import WxDateSelect from '@/views/wx/product/WxDateSelect'
import RemoteVanSelect from '@/components/selector/RemoteVanSelect'
import authority from '@/utils/authority'
import WxSelectOutGoods from '@/views/wx/product/WxSelectOutGoods'
import { findGoods } from '@/utils/request'

export default {
  name: 'WxNeilingGoods',
  mixins: [resizeCaptureMixin],
  components: {
    WxSelectOutGoods,
    RemoteVanSelect,
    WxDateSelect,
    WxWarehouseSelect,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker
  },
  data () {
    return {
      neiling: new Neiling(),
      selectGoodsPopup: {
        show: false,
        neiling: new Neiling()
      },
      goodsList: null,
      oldNeiling: null
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'NeilingUser')
    this.neiling.operatorUserAccount = this.$store.state.user.userAccount
    this.$store.dispatch('neiling/all').then(list => {
      for (const neiling of list) {
        if (neiling.id.toString() === this.$route.query.neilingId) {
          this.neiling = neiling
          this.oldNeiling = this.$_.cloneDeep(this.neiling)
          break
        }
      }
    })
  },
  methods: {
    selectGoods () {
      if (!this.neiling.warehouse || !this.neiling.warehouse[1]) {
        Toast.fail('请选择仓库！')
        return
      }
      this.selectGoodsPopup.neiling = this.$_.cloneDeep(this.neiling)
      this.selectGoodsPopup.show = true
    },
    deleteGoods (goods) {
      this.$confirm(`确认删除商品【${goods.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (const index in this.neiling.goodsList) {
          const item = this.neiling.goodsList[index]
          if (item.id === goods.id) {
            this.neiling.goodsList.splice(index, 1)
          }
        }
      }).catch(() => {
      })
    },
    updateGoodsList (goodsList) {
      this.neiling.goodsList = goodsList
    },
    applyNeiling () {
      if (!this.check()) return
      if (this.neiling.goodsList.length === 0) {
        Toast.fail('请选择商品！')
        return
      }
      this.neiling.status = 1
      this.save()
    },
    save () {
      if (!this.check()) return
      if (typeof this.neiling.outDate === 'object') {
        this.neiling.outDate = this.neiling.outDate.format('yyyy-MM-dd')
      }
      const isAdd = !this.neiling.id
      this.$store.dispatch('neiling/' + (isAdd ? 'add' : 'updateOne'), this.$_.cloneDeep(this.neiling)).then(() => {
        this.$router.go(-1)
        this.$message.success((this.neiling.status === 0 ? '保存' : '提交申请') + '成功!')
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    check () {
      if (!this.neiling.warehouse || !this.neiling.warehouse[1]) {
        Toast.fail('请选择仓库！')
        return false
      }
      if (!this.neiling.outDate) {
        Toast.fail('请选择内领日期！')
        return false
      }
      return true
    }
  },
  computed: {
    readOnly () {
      return this.neiling.status !== 0 || !this.$hasPermission(authority.NEILING)
    },
    listHeight () {
      return this.clientHeight - 110 - 20 - 20
    },
    neilingUserOptions () {
      const options = [{ value: this.$store.state.user.userAccount, text: this.$store.state.user.name }]
      for (const item of this.$store.state.data.NeilingUser || []) {
        options.push({ value: item.account, text: item.name })
      }
      return options
    }
  },
  watch: {
    'neiling.warehouse': {
      handler (warehouse) {
        if (warehouse && warehouse[1]) {
          this.neiling.goodsList = this.neiling.goodsList
            .filter(item => item.warehouseId === warehouse[0] && item.warehousePosId === warehouse[1])
          findGoods({ warehouseId: warehouse[0], warehousePosId: warehouse[1] }).then(resp => {
            this.goodsList = resp.data
            if (this.oldNeiling) {
              for (const goods of this.goodsList) {
                for (const oldGoods of this.oldNeiling.goodsList) {
                  if (goods.id === oldGoods.id && goods.inboundId === oldGoods.inboundId) {
                    goods.remain += oldGoods.num
                    break
                  }
                }
              }
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: inline-block;
  width: 100px;
  color: #646464;
  font-size: 14px;
  text-align: right;
  height: 28px;
  line-height: 28px;
}

.value {
  display: inline-block;
  color: black;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  margin-left: 20px;
}

/deep/
.el-input--small .el-input__inner {
  height: 28px;
  line-height: 28px;
}
</style>
